import React from 'react';
import { Modal } from 'antd';

import Button from 'components/Button';
import DF from 'DisplayFramework';
import PAYDetail from './PAYDetail/index';
import GetLabel from 'DisplayFramework/components/GetLabel';

type PayementModalProps = {
  onCancel: () => void;
  visible: boolean;
  onSuccess?: () => void;
  showAsModal?: boolean;
  payid?: number;
  hideButtons?: boolean;
};

const PayementModal = (props: PayementModalProps) => {
  const { onCancel, visible, payid, hideButtons } = props;

  return (
    <DF.Provider pagcode="PayementModal">
      <Modal
        visible={visible}
        onCancel={onCancel}
        width={1400}
        title={<GetLabel label="PaymentModal" />}
        footer={[<Button key="cancel" comcode="cancel" onClick={onCancel} />]}
      >
        <PAYDetail hideButtons={hideButtons} showAsModal payid={payid} />
      </Modal>
    </DF.Provider>
  );
};

export default PayementModal;
